import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { GroupsPageResponse } from 'types/group';
import { PhoneNumbersPageResponse } from 'types/phoneNumber';
import phoneNumberQueryKeys from './phoneNumberQueryKeys';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  options?: Omit<
    UseQueryOptions<
      PhoneNumbersPageResponse,
      Error,
      PhoneNumbersPageResponse,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >;
}

export const useListPhoneNumbersQuery = ({
  skip = 0,
  take = 10000,
  orderBy = [['number', 'asc']],
  filters = {},
  options,
}: QueryParams) => {
  // returns list of phoneNumbers
  // - just get ALL phoneNumbers+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = phoneNumberQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<PhoneNumbersPageResponse, Error>(
    queryKey,
    () =>
      sdk.phoneNumber.query.phoneNumbers(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
      ...options,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListPhoneNumbersQuery;
